export const BonusesEnum = {
    Bonuses: 0,
    BonusHistory: 1,
}

Object.freeze(BonusesEnum);


export default BonusesEnum;